// import React, { useState, useEffect } from "react";
// import {
//   Box,
//   Typography,
//   Button,
//   TextField,
//   Paper,
//   Grid,
//   Card,
//   CardContent,
//   CircularProgress,
//   AppBar,
//   Toolbar,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Chip,
//   Alert,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   IconButton,
// } from "@mui/material";
// import {
//   TrendingUp as TrendingUpIcon,
//   EmojiEvents as EmojiEventsIcon,
//   People as PeopleIcon,
//   LocalBar as MilkIcon,
//   Close as CloseIcon,
//   Download as DownloadIcon,
//   CalendarToday as CalendarIcon,
//   BarChart as BarChartIcon,
//   Cow as CowIcon,
//   Schedule as ScheduleIcon,
// } from "@mui/icons-material";
// import { useNavigate } from "react-router-dom";
// import swal from "sweetalert";

// const ProductionReportPage = () => {
//   const navigate = useNavigate();
//   const [reportData, setReportData] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [generating, setGenerating] = useState(false);
  
//   // Report Periods
//   const reportPeriods = [
//     { value: "today", label: "Today" },
//     { value: "yesterday", label: "Yesterday" },
//     { value: "week", label: "This Week" },
//     { value: "month", label: "This Month" },
//     { value: "quarter", label: "This Quarter" },
//     { value: "year", label: "This Year" },
//     { value: "custom", label: "Custom Range" }
//   ];

//   const [reportPeriod, setReportPeriod] = useState("week");
//   const [filters, setFilters] = useState({
//     start_date: new Date().toISOString().split('T')[0],
//     end_date: new Date().toISOString().split('T')[0]
//   });

//   const [comparisonPeriod, setComparisonPeriod] = useState("previous_period");
//   const [comparisonData, setComparisonData] = useState(null);
//   const [exportDialogOpen, setExportDialogOpen] = useState(false);
//   const [exportFormat, setExportFormat] = useState("pdf");

//   const API_URL = "https://dairy.server.statify.co.ke/api/milking";

//   // Calculate date ranges
//   const calculateDateRange = (period) => {
//     const today = new Date();
//     let startDate, endDate;

//     switch (period) {
//       case "today":
//         startDate = today.toISOString().split('T')[0];
//         endDate = startDate;
//         break;
//       case "yesterday":
//         const yesterday = new Date(today);
//         yesterday.setDate(yesterday.getDate() - 1);
//         startDate = yesterday.toISOString().split('T')[0];
//         endDate = startDate;
//         break;
//       case "week":
//         const weekStart = new Date(today);
//         weekStart.setDate(today.getDate() - today.getDay());
//         startDate = weekStart.toISOString().split('T')[0];
//         endDate = today.toISOString().split('T')[0];
//         break;
//       case "month":
//         const monthStart = new Date(today.getFullYear(), today.getMonth(), 1);
//         startDate = monthStart.toISOString().split('T')[0];
//         endDate = today.toISOString().split('T')[0];
//         break;
//       case "quarter":
//         const quarter = Math.floor(today.getMonth() / 3);
//         const quarterStart = new Date(today.getFullYear(), quarter * 3, 1);
//         startDate = quarterStart.toISOString().split('T')[0];
//         endDate = today.toISOString().split('T')[0];
//         break;
//       case "year":
//         const yearStart = new Date(today.getFullYear(), 0, 1);
//         startDate = yearStart.toISOString().split('T')[0];
//         endDate = today.toISOString().split('T')[0];
//         break;
//       case "custom":
//         startDate = filters.start_date;
//         endDate = filters.end_date;
//         break;
//       default:
//         startDate = today.toISOString().split('T')[0];
//         endDate = startDate;
//     }

//     return { startDate, endDate };
//   };

//   // Fetch Report Data
//   const fetchReportData = async (period = reportPeriod, isComparison = false) => {
//     setLoading(true);
//     try {
//       const { startDate, endDate } = calculateDateRange(period);
      
//       const params = new URLSearchParams({ 
//         start_date: startDate, 
//         end_date: endDate 
//       });
      
//       const url = `${API_URL}/stats?${params.toString()}`;
//       const res = await fetch(url);
      
//       if (res.ok) {
//         const data = await res.json();
        
//         // Fetch operator details for top operators
//         if (data.top_operators && data.top_operators.length > 0) {
//           const operatorsWithDetails = await Promise.all(
//             data.top_operators.map(async (operator) => {
//               if (operator.operator && operator.operator.id) {
//                 try {
//                   // Fetch operator details from user endpoint
//                   const operatorRes = await fetch(`https://dairy.server.statify.co.ke/api/employees/${operator.operator.id}`);
//                   if (operatorRes.ok) {
//                     const operatorData = await operatorRes.json();
//                     return {
//                       ...operator,
//                       operator: {
//                         ...operator.operator,
//                         first_name: operatorData.first_name || 'Unknown',
//                         last_name: operatorData.last_name || '',
//                         email: operatorData.email || '',
//                         role: operatorData.role || 'Operator'
//                       }
//                     };
//                   }
//                 } catch (error) {
//                   console.error('Error fetching operator details:', error);
//                 }
//               }
//               return operator;
//             })
//           );
//           data.top_operators = operatorsWithDetails;
//         }
        
//         if (isComparison) {
//           setComparisonData(data);
//         } else {
//           setReportData({
//             ...data,
//             period: period,
//             start_date: startDate,
//             end_date: endDate
//           });
//         }
//       } else {
//         if (isComparison) {
//           setComparisonData(null);
//         } else {
//           setReportData(null);
//         }
//       }
//     } catch (err) {
//       console.error('Error fetching report data:', err);
//       swal("Error", "Failed to fetch report data", "error");
//       if (isComparison) {
//         setComparisonData(null);
//       } else {
//         setReportData(null);
//       }
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Fetch comparison data
//   const fetchComparisonData = async () => {
//     let comparisonPeriod;
    
//     switch (reportPeriod) {
//       case "today":
//         comparisonPeriod = "yesterday";
//         break;
//       case "yesterday":
//         comparisonPeriod = "today";
//         break;
//       case "week":
//         comparisonPeriod = "last_week";
//         break;
//       case "month":
//         comparisonPeriod = "last_month";
//         break;
//       default:
//         comparisonPeriod = "previous_period";
//     }
    
//     await fetchReportData(comparisonPeriod, true);
//   };

//   // Fetch operator sessions data
//   const fetchOperatorSessions = async () => {
//     try {
//       const { startDate, endDate } = calculateDateRange(reportPeriod);
      
//       const params = new URLSearchParams({ 
//         start_date: startDate, 
//         end_date: endDate 
//       });
      
//       const url = `${API_URL}/sessions?${params.toString()}`;
//       const res = await fetch(url);
      
//       if (res.ok) {
//         const data = await res.json();
//         return data.sessions || [];
//       }
//       return [];
//     } catch (error) {
//       console.error('Error fetching operator sessions:', error);
//       return [];
//     }
//   };

//   // Calculate operator statistics from sessions
//   const calculateOperatorStats = (sessions) => {
//     const operatorStats = {};
    
//     sessions.forEach(session => {
//       if (session.operator_id) {
//         const operatorId = session.operator_id;
        
//         if (!operatorStats[operatorId]) {
//           operatorStats[operatorId] = {
//             operator_id: operatorId,
//             total_yield: 0,
//             session_count: 0,
//             operator: {
//               id: operatorId,
//               first_name: `Operator ${operatorId}`,
//               last_name: '',
//               email: '',
//               role: 'Operator'
//             }
//           };
//         }
        
//         operatorStats[operatorId].total_yield += session.yield_liters || 0;
//         operatorStats[operatorId].session_count += 1;
//       }
//     });
    
//     // Fetch operator details for each operator
//     Object.values(operatorStats).forEach(async (operatorStat) => {
//       try {
//         const operatorRes = await fetch(`https://dairy.server.statify.co.ke/api/users/${operatorStat.operator_id}`);
//         if (operatorRes.ok) {
//           const operatorData = await operatorRes.json();
//           operatorStat.operator = {
//             ...operatorStat.operator,
//             first_name: operatorData.first_name || `Operator ${operatorStat.operator_id}`,
//             last_name: operatorData.last_name || '',
//             email: operatorData.email || '',
//             role: operatorData.role || 'Operator'
//           };
//         }
//       } catch (error) {
//         console.error('Error fetching operator details:', error);
//       }
//     });
    
//     return Object.values(operatorStats).sort((a, b) => b.total_yield - a.total_yield).slice(0, 5);
//   };

//   // Initial data fetch
//   useEffect(() => {
//     fetchReportData();
//   }, []);

//   // Handle period change
//   const handlePeriodChange = (newPeriod) => {
//     setReportPeriod(newPeriod);
//     fetchReportData(newPeriod);
//   };

//   // Handle filter change
//   const handleFilterChange = (key, value) => {
//     setFilters(prev => ({
//       ...prev,
//       [key]: value
//     }));
//   };

//   // Apply custom date range
//   const applyCustomDateRange = () => {
//     fetchReportData("custom");
//   };

//   // Calculate percentage change
//   const calculateChange = (current, previous) => {
//     if (!previous || previous === 0) return null;
//     const change = ((current - previous) / previous) * 100;
//     return change;
//   };

//   // Get change color and icon
//   const getChangeProps = (change) => {
//     if (change === null || change === undefined) return { color: 'default', icon: '➖' };
    
//     if (change > 0) return { color: 'success', icon: '📈' };
//     if (change < 0) return { color: 'error', icon: '📉' };
//     return { color: 'default', icon: '➖' };
//   };

//   // Format number
//   const formatNumber = (num, decimals = 1) => {
//     if (num === null || num === undefined) return '0';
//     return Number(num).toFixed(decimals);
//   };

//   // Generate PDF Report
//   const generatePDFReport = () => {
//     setGenerating(true);
    
//     // Simulate PDF generation
//     setTimeout(() => {
//       const reportWindow = window.open("", "_blank");
//       const reportContent = `
//         <html>
//           <head>
//             <title>Milk Production Report</title>
//             <style>
//               body { 
//                 font-family: Arial, sans-serif; 
//                 margin: 40px; 
//                 color: #333;
//               }
//               .header { 
//                 text-align: center; 
//                 border-bottom: 3px solid #1976d2; 
//                 padding-bottom: 20px;
//                 margin-bottom: 30px;
//               }
//               .summary-stats { 
//                 display: grid;
//                 grid-template-columns: repeat(4, 1fr);
//                 gap: 20px;
//                 margin: 30px 0;
//               }
//               .stat-card {
//                 border: 1px solid #ddd;
//                 padding: 20px;
//                 text-align: center;
//                 border-radius: 8px;
//                 background: #f9f9f9;
//               }
//               .stat-value {
//                 font-size: 24px;
//                 font-weight: bold;
//                 color: #1976d2;
//                 margin: 10px 0;
//               }
//               .section {
//                 margin: 30px 0;
//               }
//               .section-title {
//                 background: #1976d2;
//                 color: white;
//                 padding: 10px;
//                 border-radius: 5px;
//                 margin-bottom: 15px;
//               }
//               table {
//                 width: 100%;
//                 border-collapse: collapse;
//                 margin: 15px 0;
//               }
//               th, td {
//                 border: 1px solid #ddd;
//                 padding: 12px;
//                 text-align: left;
//               }
//               th {
//                 background: #f5f5f5;
//                 font-weight: bold;
//               }
//               .footer {
//                 margin-top: 50px;
//                 text-align: center;
//                 font-size: 12px;
//                 color: #666;
//                 border-top: 1px solid #ddd;
//                 padding-top: 20px;
//               }
//               .positive { color: #4caf50; }
//               .negative { color: #f44336; }
//             </style>
//           </head>
//           <body>
//             <div class="header">
//               <h1>🥛 Milk Production Report</h1>
//               <h2>${reportData?.start_date} to ${reportData?.end_date}</h2>
//               <p>Generated on: ${new Date().toLocaleDateString()}</p>
//             </div>

//             <div class="summary-stats">
//               <div class="stat-card">
//                 <div>Total Milk</div>
//                 <div class="stat-value">${formatNumber(reportData?.total_milk_produced)} L</div>
//               </div>
//               <div class="stat-card">
//                 <div>Total Sessions</div>
//                 <div class="stat-value">${reportData?.total_sessions || 0}</div>
//               </div>
//               <div class="stat-card">
//                 <div>Avg Yield/Session</div>
//                 <div class="stat-value">${formatNumber(reportData?.average_yield_per_session)} L</div>
//               </div>
//               <div class="stat-card">
//                 <div>Cows Milked</div>
//                 <div class="stat-value">${reportData?.unique_cows_milked || 0}</div>
//               </div>
//             </div>

//             ${reportData?.top_producing_cows && reportData.top_producing_cows.length > 0 ? `
//             <div class="section">
//               <div class="section-title">
//                 <h3>🏆 Top Producing Cows</h3>
//               </div>
//               <table>
//                 <thead>
//                   <tr>
//                     <th>Rank</th>
//                     <th>Cow Tag</th>
//                     <th>Name</th>
//                     <th>Total Yield (L)</th>
//                     <th>Sessions</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   ${reportData.top_producing_cows.map((cow, index) => `
//                     <tr>
//                       <td>#${index + 1}</td>
//                       <td>${cow.animal?.tag_number || 'Unknown'}</td>
//                       <td>${cow.animal?.name || 'Unnamed'}</td>
//                       <td>${formatNumber(cow.total_yield)}</td>
//                       <td>${cow.session_count}</td>
//                     </tr>
//                   `).join('')}
//                 </tbody>
//               </table>
//             </div>
//             ` : ''}

//             ${reportData?.top_operators && reportData.top_operators.length > 0 ? `
//             <div class="section">
//               <div class="section-title">
//                 <h3>👥 Top Operators</h3>
//               </div>
//               <table>
//                 <thead>
//                   <tr>
//                     <th>Rank</th>
//                     <th>Operator Name</th>
//                     <th>Total Yield (L)</th>
//                     <th>Sessions</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   ${reportData.top_operators.map((operator, index) => `
//                     <tr>
//                       <td>#${index + 1}</td>
//                       <td>${operator.operator ? `${operator.operator.first_name} ${operator.operator.last_name}` : 'Unknown'}</td>
//                       <td>${formatNumber(operator.total_yield)}</td>
//                       <td>${operator.session_count}</td>
//                     </tr>
//                   `).join('')}
//                 </tbody>
//               </table>
//             </div>
//             ` : ''}

//             ${comparisonData ? `
//             <div class="section">
//               <div class="section-title">
//                 <h3>📊 Performance Comparison</h3>
//               </div>
//               <table>
//                 <thead>
//                   <tr>
//                     <th>Metric</th>
//                     <th>Current Period</th>
//                     <th>Previous Period</th>
//                     <th>Change</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   <tr>
//                     <td>Total Milk Production</td>
//                     <td>${formatNumber(reportData?.total_milk_produced)} L</td>
//                     <td>${formatNumber(comparisonData?.total_milk_produced)} L</td>
//                     <td class="${calculateChange(reportData?.total_milk_produced, comparisonData?.total_milk_produced) > 0 ? 'positive' : 'negative'}">
//                       ${calculateChange(reportData?.total_milk_produced, comparisonData?.total_milk_produced)?.toFixed(1) || '0'}%
//                     </td>
//                   </tr>
//                   <tr>
//                     <td>Average Yield/Session</td>
//                     <td>${formatNumber(reportData?.average_yield_per_session)} L</td>
//                     <td>${formatNumber(comparisonData?.average_yield_per_session)} L</td>
//                     <td class="${calculateChange(reportData?.average_yield_per_session, comparisonData?.average_yield_per_session) > 0 ? 'positive' : 'negative'}">
//                       ${calculateChange(reportData?.average_yield_per_session, comparisonData?.average_yield_per_session)?.toFixed(1) || '0'}%
//                     </td>
//                   </tr>
//                 </tbody>
//               </table>
//             </div>
//             ` : ''}

//             <div class="footer">
//               <p>Report generated by Milk Production System on ${new Date().toLocaleString()}</p>
//               <p>© ${new Date().getFullYear()} Dairy Management System</p>
//             </div>
//           </body>
//         </html>
//       `;
      
//       reportWindow.document.write(reportContent);
//       reportWindow.document.close();
//       setGenerating(false);
//       setExportDialogOpen(false);
      
//       setTimeout(() => {
//         reportWindow.print();
//       }, 500);
      
//     }, 2000);
//   };

//   // Export data as CSV
//   const exportCSV = () => {
//     if (!reportData) return;

//     let csvContent = "Milk Production Report\n";
//     csvContent += `Period: ${reportData.start_date} to ${reportData.end_date}\n`;
//     csvContent += `Generated: ${new Date().toLocaleString()}\n\n`;

//     // Summary stats
//     csvContent += "SUMMARY STATISTICS\n";
//     csvContent += `Total Milk Produced,${formatNumber(reportData.total_milk_produced)} L\n`;
//     csvContent += `Total Sessions,${reportData.total_sessions || 0}\n`;
//     csvContent += `Average Yield/Session,${formatNumber(reportData.average_yield_per_session)} L\n`;
//     csvContent += `Unique Cows Milked,${reportData.unique_cows_milked || 0}\n\n`;

//     // Top producing cows
//     if (reportData.top_producing_cows && reportData.top_producing_cows.length > 0) {
//       csvContent += "TOP PRODUCING COWS\n";
//       csvContent += "Rank,Cow Tag,Name,Total Yield (L),Sessions\n";
//       reportData.top_producing_cows.forEach((cow, index) => {
//         csvContent += `${index + 1},${cow.animal?.tag_number || 'Unknown'},${cow.animal?.name || 'Unnamed'},${formatNumber(cow.total_yield)},${cow.session_count}\n`;
//       });
//       csvContent += "\n";
//     }

//     // Top operators
//     if (reportData.top_operators && reportData.top_operators.length > 0) {
//       csvContent += "TOP OPERATORS\n";
//       csvContent += "Rank,Operator Name,Total Yield (L),Sessions\n";
//       reportData.top_operators.forEach((operator, index) => {
//         csvContent += `${index + 1},${operator.operator ? `${operator.operator.first_name} ${operator.operator.last_name}` : 'Unknown'},${formatNumber(operator.total_yield)},${operator.session_count}\n`;
//       });
//     }

//     // Create and download CSV file
//     const blob = new Blob([csvContent], { type: 'text/csv' });
//     const url = window.URL.createObjectURL(blob);
//     const a = document.createElement('a');
//     a.href = url;
//     a.download = `milk-production-report-${reportData.start_date}-to-${reportData.end_date}.csv`;
//     document.body.appendChild(a);
//     a.click();
//     document.body.removeChild(a);
//     window.URL.revokeObjectURL(url);
    
//     setExportDialogOpen(false);
//     swal("Success", "CSV report downloaded successfully!", "success");
//   };

//   // Handle export
//   const handleExport = () => {
//     if (exportFormat === "pdf") {
//       generatePDFReport();
//     } else if (exportFormat === "csv") {
//       exportCSV();
//     }
//   };

//   return (
//     <Box sx={{ flexGrow: 1, minHeight: '100vh', backgroundColor: 'background.default' }}>
//       {/* Header */}
//       <AppBar position="static" elevation={2} sx={{ backgroundColor: 'info.dark' }}>
//         <Toolbar>
//           <TrendingUpIcon sx={{ mr: 2 }} />
//           <Typography variant="h4" component="h1" sx={{ flexGrow: 1, fontWeight: 'bold' }}>
//             Production Reports
//           </Typography>
//           <Button 
//             variant="outlined" 
//             startIcon={<DownloadIcon />}
//             onClick={() => setExportDialogOpen(true)}
//             sx={{ 
//               borderRadius: 2, 
//               color: 'white', 
//               borderColor: 'white',
//               '&:hover': {
//                 backgroundColor: 'rgba(255,255,255,0.1)',
//                 borderColor: 'white'
//               }
//             }}
//           >
//             Export Report
//           </Button>
//         </Toolbar>
//       </AppBar>

//       {/* Main Content */}
//       <Box sx={{ p: 3 }}>
//         <Paper sx={{ borderRadius: 2, border: 2, borderColor: 'info.light', overflow: 'hidden' }}>
//           {/* Report Controls */}
//           <Box sx={{ p: 3, borderBottom: 1, borderColor: 'divider', backgroundColor: 'background.paper' }}>
//             <Grid container spacing={3} alignItems="center">
//               <Grid item xs={12} md={6}>
//                 <Typography variant="h6" gutterBottom>
//                   Report Period
//                 </Typography>
//                 <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
//                   {reportPeriods.map((period) => (
//                     <Button
//                       key={period.value}
//                       variant={reportPeriod === period.value ? "contained" : "outlined"}
//                       onClick={() => handlePeriodChange(period.value)}
//                       color="info"
//                       size="small"
//                       sx={{ borderRadius: 2 }}
//                     >
//                       {period.label}
//                     </Button>
//                   ))}
//                 </Box>
                
//                 {reportPeriod === "custom" && (
//                   <Box sx={{ mt: 2, display: 'flex', gap: 2, alignItems: 'center', flexWrap: 'wrap' }}>
//                     <TextField
//                       label="Start Date"
//                       type="date"
//                       value={filters.start_date}
//                       onChange={(e) => handleFilterChange('start_date', e.target.value)}
//                       InputLabelProps={{ shrink: true }}
//                       size="small"
//                     />
//                     <TextField
//                       label="End Date"
//                       type="date"
//                       value={filters.end_date}
//                       onChange={(e) => handleFilterChange('end_date', e.target.value)}
//                       InputLabelProps={{ shrink: true }}
//                       size="small"
//                     />
//                     <Button 
//                       variant="contained" 
//                       onClick={applyCustomDateRange}
//                       size="small"
//                     >
//                       Apply
//                     </Button>
//                   </Box>
//                 )}
//               </Grid>

//               <Grid item xs={12} md={6}>
//                 <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end', flexWrap: 'wrap' }}>
//                   <Button
//                     variant="outlined"
//                     onClick={fetchComparisonData}
//                     disabled={!reportData}
//                     startIcon={<BarChartIcon />}
//                   >
//                     Compare with Previous
//                   </Button>
//                   <Button
//                     variant="contained"
//                     onClick={() => fetchReportData()}
//                     color="primary"
//                     startIcon={<CalendarIcon />}
//                   >
//                     Refresh Data
//                   </Button>
//                 </Box>
//               </Grid>
//             </Grid>
//           </Box>

//           {/* Report Content */}
//           <Box sx={{ p: 3 }}>
//             {loading ? (
//               <Box sx={{ display: 'flex', justifyContent: 'center', p: 6 }}>
//                 <CircularProgress color="info" size={60} />
//               </Box>
//             ) : reportData ? (
//               <Grid container spacing={4}>
//                 {/* Summary Stats */}
//                 <Grid item xs={12}>
//                   <Typography variant="h5" gutterBottom color="primary" sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 3 }}>
//                     <MilkIcon /> Production Summary
//                   </Typography>
//                   <Grid container spacing={3}>
//                     <Grid item xs={12} sm={6} md={3}>
//                       <Card sx={{ textAlign: 'center', p: 3, backgroundColor: 'primary.main', color: 'white', height: '100%' }}>
//                         <Typography variant="h4" sx={{ fontWeight: 'bold', mb: 1 }}>
//                           {formatNumber(reportData.total_milk_produced)}
//                         </Typography>
//                         <Typography variant="body1">Total Milk (L)</Typography>
//                         {comparisonData && (
//                           <Chip 
//                             label={`${calculateChange(reportData.total_milk_produced, comparisonData.total_milk_produced)?.toFixed(1) || '0'}%`}
//                             color={getChangeProps(calculateChange(reportData.total_milk_produced, comparisonData.total_milk_produced)).color}
//                             size="small"
//                             sx={{ mt: 1, color: 'white' }}
//                           />
//                         )}
//                       </Card>
//                     </Grid>
//                     <Grid item xs={12} sm={6} md={3}>
//                       <Card sx={{ textAlign: 'center', p: 3, backgroundColor: 'secondary.main', color: 'white', height: '100%' }}>
//                         <Typography variant="h4" sx={{ fontWeight: 'bold', mb: 1 }}>
//                           {reportData.total_sessions || 0}
//                         </Typography>
//                         <Typography variant="body1">Total Sessions</Typography>
//                         {comparisonData && (
//                           <Chip 
//                             label={`${calculateChange(reportData.total_sessions, comparisonData.total_sessions)?.toFixed(1) || '0'}%`}
//                             color={getChangeProps(calculateChange(reportData.total_sessions, comparisonData.total_sessions)).color}
//                             size="small"
//                             sx={{ mt: 1, color: 'white' }}
//                           />
//                         )}
//                       </Card>
//                     </Grid>
//                     <Grid item xs={12} sm={6} md={3}>
//                       <Card sx={{ textAlign: 'center', p: 3, backgroundColor: 'success.main', color: 'white', height: '100%' }}>
//                         <Typography variant="h4" sx={{ fontWeight: 'bold', mb: 1 }}>
//                           {formatNumber(reportData.average_yield_per_session)}
//                         </Typography>
//                         <Typography variant="body1">Avg Yield/Session (L)</Typography>
//                         {comparisonData && (
//                           <Chip 
//                             label={`${calculateChange(reportData.average_yield_per_session, comparisonData.average_yield_per_session)?.toFixed(1) || '0'}%`}
//                             color={getChangeProps(calculateChange(reportData.average_yield_per_session, comparisonData.average_yield_per_session)).color}
//                             size="small"
//                             sx={{ mt: 1, color: 'white' }}
//                           />
//                         )}
//                       </Card>
//                     </Grid>
//                     <Grid item xs={12} sm={6} md={3}>
//                       <Card sx={{ textAlign: 'center', p: 3, backgroundColor: 'warning.main', color: 'white', height: '100%' }}>
//                         <Typography variant="h4" sx={{ fontWeight: 'bold', mb: 1 }}>
//                           {reportData.unique_cows_milked || 0}
//                         </Typography>
//                         <Typography variant="body1">Cows Milked</Typography>
//                         {comparisonData && (
//                           <Chip 
//                             label={`${calculateChange(reportData.unique_cows_milked, comparisonData.unique_cows_milked)?.toFixed(1) || '0'}%`}
//                             color={getChangeProps(calculateChange(reportData.unique_cows_milked, comparisonData.unique_cows_milked)).color}
//                             size="small"
//                             sx={{ mt: 1, color: 'white' }}
//                           />
//                         )}
//                       </Card>
//                     </Grid>
//                   </Grid>
//                 </Grid>

//                 {/* Top Producing Cows */}
//                 {reportData.top_producing_cows && reportData.top_producing_cows.length > 0 && (
//                   <Grid item xs={12} md={6}>
//                     <Card sx={{ p: 3, height: '100%' }}>
//                       <Typography variant="h6" gutterBottom color="primary" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                         <EmojiEventsIcon /> Top Producing Cows
//                       </Typography>
//                       <TableContainer>
//                         <Table size="small">
//                           <TableHead>
//                             <TableRow>
//                               <TableCell>Rank</TableCell>
//                               <TableCell>Cow</TableCell>
//                               <TableCell align="right">Yield (L)</TableCell>
//                               <TableCell align="right">Sessions</TableCell>
//                             </TableRow>
//                           </TableHead>
//                           <TableBody>
//                             {reportData.top_producing_cows.map((cow, index) => (
//                               <TableRow key={cow.animal?.id || index} hover>
//                                 <TableCell>
//                                   <Chip 
//                                     label={`#${index + 1}`} 
//                                     size="small" 
//                                     color={index === 0 ? 'warning' : 'default'}
//                                   />
//                                 </TableCell>
//                                 <TableCell>
//                                   <Box>
//                                     <Typography variant="body2" fontWeight="bold">
//                                       {cow.animal?.tag_number || 'Unknown'}
//                                     </Typography>
//                                     <Typography variant="body2" color="textSecondary">
//                                       {cow.animal?.name || 'Unnamed'}
//                                     </Typography>
//                                   </Box>
//                                 </TableCell>
//                                 <TableCell align="right">
//                                   <Typography variant="body2" fontWeight="bold" color="primary">
//                                     {formatNumber(cow.total_yield)}
//                                   </Typography>
//                                 </TableCell>
//                                 <TableCell align="right">
//                                   <Typography variant="body2">
//                                     {cow.session_count}
//                                   </Typography>
//                                 </TableCell>
//                               </TableRow>
//                             ))}
//                           </TableBody>
//                         </Table>
//                       </TableContainer>
//                     </Card>
//                   </Grid>
//                 )}

//                 {/* Top Operators */}
//                 {reportData.top_operators && reportData.top_operators.length > 0 && (
//                   <Grid item xs={12} md={6}>
//                     <Card sx={{ p: 3, height: '100%' }}>
//                       <Typography variant="h6" gutterBottom color="primary" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                         <PeopleIcon /> Top Operators
//                       </Typography>
//                       <TableContainer>
//                         <Table size="small">
//                           <TableHead>
//                             <TableRow>
//                               <TableCell>Rank</TableCell>
//                               <TableCell>Operator</TableCell>
//                               <TableCell align="right">Yield (L)</TableCell>
//                               <TableCell align="right">Sessions</TableCell>
//                             </TableRow>
//                           </TableHead>
//                           <TableBody>
//                             {reportData.top_operators.map((operator, index) => (
//                               <TableRow key={operator.operator?.id || index} hover>
//                                 <TableCell>
//                                   <Chip 
//                                     label={`#${index + 1}`} 
//                                     size="small" 
//                                     color={index === 0 ? 'success' : 'default'}
//                                   />
//                                 </TableCell>
//                                 <TableCell>
//                                   <Box>
//                                     <Typography variant="body2" fontWeight="bold">
//                                       {operator.operator ? 
//                                         `${operator.operator.first_name} ${operator.operator.last_name}` : 
//                                         `Operator ${operator.operator_id || 'Unknown'}`
//                                       }
//                                     </Typography>
//                                     {operator.operator?.email && (
//                                       <Typography variant="body2" color="textSecondary">
//                                         {operator.operator.email}
//                                       </Typography>
//                                     )}
//                                   </Box>
//                                 </TableCell>
//                                 <TableCell align="right">
//                                   <Typography variant="body2" fontWeight="bold" color="primary">
//                                     {formatNumber(operator.total_yield)}
//                                   </Typography>
//                                 </TableCell>
//                                 <TableCell align="right">
//                                   <Typography variant="body2">
//                                     {operator.session_count}
//                                   </Typography>
//                                 </TableCell>
//                               </TableRow>
//                             ))}
//                           </TableBody>
//                         </Table>
//                       </TableContainer>
//                     </Card>
//                   </Grid>
//                 )}

//                 {/* Comparison Data */}
//                 {comparisonData && (
//                   <Grid item xs={12}>
//                     <Card sx={{ p: 3 }}>
//                       <Typography variant="h6" gutterBottom color="primary" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                         <BarChartIcon /> Performance Comparison
//                       </Typography>
//                       <TableContainer>
//                         <Table>
//                           <TableHead>
//                             <TableRow>
//                               <TableCell>Metric</TableCell>
//                               <TableCell align="right">Current Period</TableCell>
//                               <TableCell align="right">Previous Period</TableCell>
//                               <TableCell align="right">Change</TableCell>
//                             </TableRow>
//                           </TableHead>
//                           <TableBody>
//                             <TableRow hover>
//                               <TableCell>
//                                 <Typography variant="body2" fontWeight="bold">
//                                   Total Milk Production
//                                 </Typography>
//                               </TableCell>
//                               <TableCell align="right">
//                                 <Typography variant="body2">
//                                   {formatNumber(reportData.total_milk_produced)} L
//                                 </Typography>
//                               </TableCell>
//                               <TableCell align="right">
//                                 <Typography variant="body2">
//                                   {formatNumber(comparisonData.total_milk_produced)} L
//                                 </Typography>
//                               </TableCell>
//                               <TableCell align="right">
//                                 <Chip 
//                                   label={`${calculateChange(reportData.total_milk_produced, comparisonData.total_milk_produced)?.toFixed(1) || '0'}%`}
//                                   color={getChangeProps(calculateChange(reportData.total_milk_produced, comparisonData.total_milk_produced)).color}
//                                   size="small"
//                                 />
//                               </TableCell>
//                             </TableRow>
//                             <TableRow hover>
//                               <TableCell>
//                                 <Typography variant="body2" fontWeight="bold">
//                                   Average Yield/Session
//                                 </Typography>
//                               </TableCell>
//                               <TableCell align="right">
//                                 <Typography variant="body2">
//                                   {formatNumber(reportData.average_yield_per_session)} L
//                                 </Typography>
//                               </TableCell>
//                               <TableCell align="right">
//                                 <Typography variant="body2">
//                                   {formatNumber(comparisonData.average_yield_per_session)} L
//                                 </Typography>
//                               </TableCell>
//                               <TableCell align="right">
//                                 <Chip 
//                                   label={`${calculateChange(reportData.average_yield_per_session, comparisonData.average_yield_per_session)?.toFixed(1) || '0'}%`}
//                                   color={getChangeProps(calculateChange(reportData.average_yield_per_session, comparisonData.average_yield_per_session)).color}
//                                   size="small"
//                                 />
//                               </TableCell>
//                             </TableRow>
//                           </TableBody>
//                         </Table>
//                       </TableContainer>
//                     </Card>
//                   </Grid>
//                 )}
//               </Grid>
//             ) : (
//               <Card sx={{ textAlign: 'center', p: 6 }}>
//                 <CardContent>
//                   <TrendingUpIcon sx={{ fontSize: 64, color: 'info.main', mb: 2 }} />
//                   <Typography variant="h5" color="info.main" gutterBottom>
//                     No Report Data Available
//                   </Typography>
//                   <Typography variant="body2" color="textSecondary" sx={{ mb: 3 }}>
//                     Select a period to generate milk production reports and analytics
//                   </Typography>
//                   <Button 
//                     variant="contained" 
//                     color="info" 
//                     onClick={() => fetchReportData()}
//                     size="large"
//                     startIcon={<BarChartIcon />}
//                   >
//                     Generate Report
//                   </Button>
//                 </CardContent>
//               </Card>
//             )}
//           </Box>
//         </Paper>
//       </Box>

//       {/* Export Dialog */}
//       <Dialog 
//         open={exportDialogOpen} 
//         onClose={() => setExportDialogOpen(false)}
//         maxWidth="sm"
//         fullWidth
//       >
//         <DialogTitle>
//           <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
//             <Typography variant="h6">Export Report</Typography>
//             <IconButton onClick={() => setExportDialogOpen(false)}>
//               <CloseIcon />
//             </IconButton>
//           </Box>
//         </DialogTitle>
//         <DialogContent>
//           <FormControl fullWidth sx={{ mt: 2 }}>
//             <InputLabel>Export Format</InputLabel>
//             <Select
//               value={exportFormat}
//               onChange={(e) => setExportFormat(e.target.value)}
//               label="Export Format"
//             >
//               <MenuItem value="pdf">PDF Document</MenuItem>
//               <MenuItem value="csv">CSV Spreadsheet</MenuItem>
//             </Select>
//           </FormControl>
//           <Alert severity="info" sx={{ mt: 2 }}>
//             {exportFormat === 'pdf' 
//               ? 'Export as printable PDF document with charts and summary tables.'
//               : 'Export as CSV spreadsheet for data analysis in Excel or other applications.'
//             }
//           </Alert>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setExportDialogOpen(false)}>Cancel</Button>
//           <Button 
//             onClick={handleExport} 
//             variant="contained" 
//             color="primary"
//             disabled={generating}
//             startIcon={generating ? <CircularProgress size={20} /> : <DownloadIcon />}
//           >
//             {generating ? 'Generating...' : 'Export Report'}
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </Box>
//   );
// };

// export default ProductionReportPage;


import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Button,
  TextField,
  Paper,
  Grid,
  Card,
  CardContent,
  CircularProgress,
  AppBar,
  Toolbar,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
  Alert,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
} from "@mui/material";
import {
  TrendingUp as TrendingUpIcon,
  EmojiEvents as EmojiEventsIcon,
  People as PeopleIcon,
  LocalBar as MilkIcon,
  Close as CloseIcon,
  Download as DownloadIcon,
  CalendarToday as CalendarIcon,
  BarChart as BarChartIcon,
  Cow as CowIcon,
  Schedule as ScheduleIcon,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import swal from "sweetalert";

// Color constants
const PRIMARY_COLOR = '#024A59';
const SECONDARY_COLOR = '#FFA916';
const PRIMARY_LIGHT = '#346875';
const PRIMARY_DARK = '#013440';

const ProductionReportPage = () => {
  const navigate = useNavigate();
  const [reportData, setReportData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [generating, setGenerating] = useState(false);
  
  // Report Periods
  const reportPeriods = [
    { value: "today", label: "Today" },
    { value: "yesterday", label: "Yesterday" },
    { value: "week", label: "This Week" },
    { value: "month", label: "This Month" },
    { value: "quarter", label: "This Quarter" },
    { value: "year", label: "This Year" },
    { value: "custom", label: "Custom Range" }
  ];

  const [reportPeriod, setReportPeriod] = useState("week");
  const [filters, setFilters] = useState({
    start_date: new Date().toISOString().split('T')[0],
    end_date: new Date().toISOString().split('T')[0]
  });

  const [comparisonPeriod, setComparisonPeriod] = useState("previous_period");
  const [comparisonData, setComparisonData] = useState(null);
  const [exportDialogOpen, setExportDialogOpen] = useState(false);
  const [exportFormat, setExportFormat] = useState("pdf");

  const API_URL = "https://dairy.server.statify.co.ke/api/milking";

  // Calculate date ranges
  const calculateDateRange = (period) => {
    const today = new Date();
    let startDate, endDate;

    switch (period) {
      case "today":
        startDate = today.toISOString().split('T')[0];
        endDate = startDate;
        break;
      case "yesterday":
        const yesterday = new Date(today);
        yesterday.setDate(yesterday.getDate() - 1);
        startDate = yesterday.toISOString().split('T')[0];
        endDate = startDate;
        break;
      case "week":
        const weekStart = new Date(today);
        weekStart.setDate(today.getDate() - today.getDay());
        startDate = weekStart.toISOString().split('T')[0];
        endDate = today.toISOString().split('T')[0];
        break;
      case "month":
        const monthStart = new Date(today.getFullYear(), today.getMonth(), 1);
        startDate = monthStart.toISOString().split('T')[0];
        endDate = today.toISOString().split('T')[0];
        break;
      case "quarter":
        const quarter = Math.floor(today.getMonth() / 3);
        const quarterStart = new Date(today.getFullYear(), quarter * 3, 1);
        startDate = quarterStart.toISOString().split('T')[0];
        endDate = today.toISOString().split('T')[0];
        break;
      case "year":
        const yearStart = new Date(today.getFullYear(), 0, 1);
        startDate = yearStart.toISOString().split('T')[0];
        endDate = today.toISOString().split('T')[0];
        break;
      case "custom":
        startDate = filters.start_date;
        endDate = filters.end_date;
        break;
      default:
        startDate = today.toISOString().split('T')[0];
        endDate = startDate;
    }

    return { startDate, endDate };
  };

  // Fetch Report Data
  const fetchReportData = async (period = reportPeriod, isComparison = false) => {
    setLoading(true);
    try {
      const { startDate, endDate } = calculateDateRange(period);
      
      const params = new URLSearchParams({ 
        start_date: startDate, 
        end_date: endDate 
      });
      
      const url = `${API_URL}/stats?${params.toString()}`;
      const res = await fetch(url);
      
      if (res.ok) {
        const data = await res.json();
        
        // Fetch operator details for top operators
        if (data.top_operators && data.top_operators.length > 0) {
          const operatorsWithDetails = await Promise.all(
            data.top_operators.map(async (operator) => {
              if (operator.operator && operator.operator.id) {
                try {
                  // Fetch operator details from user endpoint
                  const operatorRes = await fetch(`https://dairy.server.statify.co.ke/api/employees/${operator.operator.id}`);
                  if (operatorRes.ok) {
                    const operatorData = await operatorRes.json();
                    return {
                      ...operator,
                      operator: {
                        ...operator.operator,
                        first_name: operatorData.first_name || 'Unknown',
                        last_name: operatorData.last_name || '',
                        email: operatorData.email || '',
                        role: operatorData.role || 'Operator'
                      }
                    };
                  }
                } catch (error) {
                  console.error('Error fetching operator details:', error);
                }
              }
              return operator;
            })
          );
          data.top_operators = operatorsWithDetails;
        }
        
        if (isComparison) {
          setComparisonData(data);
        } else {
          setReportData({
            ...data,
            period: period,
            start_date: startDate,
            end_date: endDate
          });
        }
      } else {
        if (isComparison) {
          setComparisonData(null);
        } else {
          setReportData(null);
        }
      }
    } catch (err) {
      console.error('Error fetching report data:', err);
      swal("Error", "Failed to fetch report data", "error");
      if (isComparison) {
        setComparisonData(null);
      } else {
        setReportData(null);
      }
    } finally {
      setLoading(false);
    }
  };

  // Fetch comparison data
  const fetchComparisonData = async () => {
    let comparisonPeriod;
    
    switch (reportPeriod) {
      case "today":
        comparisonPeriod = "yesterday";
        break;
      case "yesterday":
        comparisonPeriod = "today";
        break;
      case "week":
        comparisonPeriod = "last_week";
        break;
      case "month":
        comparisonPeriod = "last_month";
        break;
      default:
        comparisonPeriod = "previous_period";
    }
    
    await fetchReportData(comparisonPeriod, true);
  };

  // Fetch operator sessions data
  const fetchOperatorSessions = async () => {
    try {
      const { startDate, endDate } = calculateDateRange(reportPeriod);
      
      const params = new URLSearchParams({ 
        start_date: startDate, 
        end_date: endDate 
      });
      
      const url = `${API_URL}/sessions?${params.toString()}`;
      const res = await fetch(url);
      
      if (res.ok) {
        const data = await res.json();
        return data.sessions || [];
      }
      return [];
    } catch (error) {
      console.error('Error fetching operator sessions:', error);
      return [];
    }
  };

  // Calculate operator statistics from sessions
  const calculateOperatorStats = (sessions) => {
    const operatorStats = {};
    
    sessions.forEach(session => {
      if (session.operator_id) {
        const operatorId = session.operator_id;
        
        if (!operatorStats[operatorId]) {
          operatorStats[operatorId] = {
            operator_id: operatorId,
            total_yield: 0,
            session_count: 0,
            operator: {
              id: operatorId,
              first_name: `Operator ${operatorId}`,
              last_name: '',
              email: '',
              role: 'Operator'
            }
          };
        }
        
        operatorStats[operatorId].total_yield += session.yield_liters || 0;
        operatorStats[operatorId].session_count += 1;
      }
    });
    
    // Fetch operator details for each operator
    Object.values(operatorStats).forEach(async (operatorStat) => {
      try {
        const operatorRes = await fetch(`https://dairy.server.statify.co.ke/api/users/${operatorStat.operator_id}`);
        if (operatorRes.ok) {
          const operatorData = await operatorRes.json();
          operatorStat.operator = {
            ...operatorStat.operator,
            first_name: operatorData.first_name || `Operator ${operatorStat.operator_id}`,
            last_name: operatorData.last_name || '',
            email: operatorData.email || '',
            role: operatorData.role || 'Operator'
          };
        }
      } catch (error) {
        console.error('Error fetching operator details:', error);
      }
    });
    
    return Object.values(operatorStats).sort((a, b) => b.total_yield - a.total_yield).slice(0, 5);
  };

  // Initial data fetch
  useEffect(() => {
    fetchReportData();
  }, []);

  // Handle period change
  const handlePeriodChange = (newPeriod) => {
    setReportPeriod(newPeriod);
    fetchReportData(newPeriod);
  };

  // Handle filter change
  const handleFilterChange = (key, value) => {
    setFilters(prev => ({
      ...prev,
      [key]: value
    }));
  };

  // Apply custom date range
  const applyCustomDateRange = () => {
    fetchReportData("custom");
  };

  // Calculate percentage change
  const calculateChange = (current, previous) => {
    if (!previous || previous === 0) return null;
    const change = ((current - previous) / previous) * 100;
    return change;
  };

  // Get change color and icon
  const getChangeProps = (change) => {
    if (change === null || change === undefined) return { color: 'default', icon: '➖' };
    
    if (change > 0) return { color: 'success', icon: '📈' };
    if (change < 0) return { color: 'error', icon: '📉' };
    return { color: 'default', icon: '➖' };
  };

  // Format number
  const formatNumber = (num, decimals = 1) => {
    if (num === null || num === undefined) return '0';
    return Number(num).toFixed(decimals);
  };

  // Generate PDF Report
  const generatePDFReport = () => {
    setGenerating(true);
    
    // Simulate PDF generation
    setTimeout(() => {
      const reportWindow = window.open("", "_blank");
      const reportContent = `
        <html>
          <head>
            <title>Milk Production Report</title>
            <style>
              body { 
                font-family: Arial, sans-serif; 
                margin: 40px; 
                color: #333;
              }
              .header { 
                text-align: center; 
                border-bottom: 3px solid ${PRIMARY_COLOR}; 
                padding-bottom: 20px;
                margin-bottom: 30px;
              }
              .summary-stats { 
                display: grid;
                grid-template-columns: repeat(4, 1fr);
                gap: 20px;
                margin: 30px 0;
              }
              .stat-card {
                border: 1px solid #ddd;
                padding: 20px;
                text-align: center;
                border-radius: 8px;
                background: #f9f9f9;
              }
              .stat-value {
                font-size: 24px;
                font-weight: bold;
                color: ${PRIMARY_COLOR};
                margin: 10px 0;
              }
              .section {
                margin: 30px 0;
              }
              .section-title {
                background: ${PRIMARY_COLOR};
                color: white;
                padding: 10px;
                border-radius: 5px;
                margin-bottom: 15px;
              }
              table {
                width: 100%;
                border-collapse: collapse;
                margin: 15px 0;
              }
              th, td {
                border: 1px solid #ddd;
                padding: 12px;
                text-align: left;
              }
              th {
                background: #f5f5f5;
                font-weight: bold;
              }
              .footer {
                margin-top: 50px;
                text-align: center;
                font-size: 12px;
                color: #666;
                border-top: 1px solid #ddd;
                padding-top: 20px;
              }
              .positive { color: #024A59; }
              .negative { color: #f44336; }
            </style>
          </head>
          <body>
            <div class="header">
              <h1>🥛 Milk Production Report</h1>
              <h2>${reportData?.start_date} to ${reportData?.end_date}</h2>
              <p>Generated on: ${new Date().toLocaleDateString()}</p>
            </div>

            <div class="summary-stats">
              <div class="stat-card">
                <div>Total Milk</div>
                <div class="stat-value">${formatNumber(reportData?.total_milk_produced)} L</div>
              </div>
              <div class="stat-card">
                <div>Total Sessions</div>
                <div class="stat-value">${reportData?.total_sessions || 0}</div>
              </div>
              <div class="stat-card">
                <div>Avg Yield/Session</div>
                <div class="stat-value">${formatNumber(reportData?.average_yield_per_session)} L</div>
              </div>
              <div class="stat-card">
                <div>Cows Milked</div>
                <div class="stat-value">${reportData?.unique_cows_milked || 0}</div>
              </div>
            </div>

            ${reportData?.top_producing_cows && reportData.top_producing_cows.length > 0 ? `
            <div class="section">
              <div class="section-title">
                <h3>🏆 Top Producing Cows</h3>
              </div>
              <table>
                <thead>
                  <tr>
                    <th>Rank</th>
                    <th>Cow Tag</th>
                    <th>Name</th>
                    <th>Total Yield (L)</th>
                    <th>Sessions</th>
                  </tr>
                </thead>
                <tbody>
                  ${reportData.top_producing_cows.map((cow, index) => `
                    <tr>
                      <td>#${index + 1}</td>
                      <td>${cow.animal?.tag_number || 'Unknown'}</td>
                      <td>${cow.animal?.name || 'Unnamed'}</td>
                      <td>${formatNumber(cow.total_yield)}</td>
                      <td>${cow.session_count}</td>
                    </tr>
                  `).join('')}
                </tbody>
              </table>
            </div>
            ` : ''}

            ${reportData?.top_operators && reportData.top_operators.length > 0 ? `
            <div class="section">
              <div class="section-title">
                <h3>👥 Top Operators</h3>
              </div>
              <table>
                <thead>
                  <tr>
                    <th>Rank</th>
                    <th>Operator Name</th>
                    <th>Total Yield (L)</th>
                    <th>Sessions</th>
                  </tr>
                </thead>
                <tbody>
                  ${reportData.top_operators.map((operator, index) => `
                    <tr>
                      <td>#${index + 1}</td>
                      <td>${operator.operator ? `${operator.operator.first_name} ${operator.operator.last_name}` : 'Unknown'}</td>
                      <td>${formatNumber(operator.total_yield)}</td>
                      <td>${operator.session_count}</td>
                    </tr>
                  `).join('')}
                </tbody>
              </table>
            </div>
            ` : ''}

            ${comparisonData ? `
            <div class="section">
              <div class="section-title">
                <h3>📊 Performance Comparison</h3>
              </div>
              <table>
                <thead>
                  <tr>
                    <th>Metric</th>
                    <th>Current Period</th>
                    <th>Previous Period</th>
                    <th>Change</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Total Milk Production</td>
                    <td>${formatNumber(reportData?.total_milk_produced)} L</td>
                    <td>${formatNumber(comparisonData?.total_milk_produced)} L</td>
                    <td class="${calculateChange(reportData?.total_milk_produced, comparisonData?.total_milk_produced) > 0 ? 'positive' : 'negative'}">
                      ${calculateChange(reportData?.total_milk_produced, comparisonData?.total_milk_produced)?.toFixed(1) || '0'}%
                    </td>
                  </tr>
                  <tr>
                    <td>Average Yield/Session</td>
                    <td>${formatNumber(reportData?.average_yield_per_session)} L</td>
                    <td>${formatNumber(comparisonData?.average_yield_per_session)} L</td>
                    <td class="${calculateChange(reportData?.average_yield_per_session, comparisonData?.average_yield_per_session) > 0 ? 'positive' : 'negative'}">
                      ${calculateChange(reportData?.average_yield_per_session, comparisonData?.average_yield_per_session)?.toFixed(1) || '0'}%
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            ` : ''}

            <div class="footer">
              <p>Report generated by Milk Production System on ${new Date().toLocaleString()}</p>
              <p>© ${new Date().getFullYear()} Dairy Management System</p>
            </div>
          </body>
        </html>
      `;
      
      reportWindow.document.write(reportContent);
      reportWindow.document.close();
      setGenerating(false);
      setExportDialogOpen(false);
      
      setTimeout(() => {
        reportWindow.print();
      }, 500);
      
    }, 2000);
  };

  // Export data as CSV
  const exportCSV = () => {
    if (!reportData) return;

    let csvContent = "Milk Production Report\n";
    csvContent += `Period: ${reportData.start_date} to ${reportData.end_date}\n`;
    csvContent += `Generated: ${new Date().toLocaleString()}\n\n`;

    // Summary stats
    csvContent += "SUMMARY STATISTICS\n";
    csvContent += `Total Milk Produced,${formatNumber(reportData.total_milk_produced)} L\n`;
    csvContent += `Total Sessions,${reportData.total_sessions || 0}\n`;
    csvContent += `Average Yield/Session,${formatNumber(reportData.average_yield_per_session)} L\n`;
    csvContent += `Unique Cows Milked,${reportData.unique_cows_milked || 0}\n\n`;

    // Top producing cows
    if (reportData.top_producing_cows && reportData.top_producing_cows.length > 0) {
      csvContent += "TOP PRODUCING COWS\n";
      csvContent += "Rank,Cow Tag,Name,Total Yield (L),Sessions\n";
      reportData.top_producing_cows.forEach((cow, index) => {
        csvContent += `${index + 1},${cow.animal?.tag_number || 'Unknown'},${cow.animal?.name || 'Unnamed'},${formatNumber(cow.total_yield)},${cow.session_count}\n`;
      });
      csvContent += "\n";
    }

    // Top operators
    if (reportData.top_operators && reportData.top_operators.length > 0) {
      csvContent += "TOP OPERATORS\n";
      csvContent += "Rank,Operator Name,Total Yield (L),Sessions\n";
      reportData.top_operators.forEach((operator, index) => {
        csvContent += `${index + 1},${operator.operator ? `${operator.operator.first_name} ${operator.operator.last_name}` : 'Unknown'},${formatNumber(operator.total_yield)},${operator.session_count}\n`;
      });
    }

    // Create and download CSV file
    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `milk-production-report-${reportData.start_date}-to-${reportData.end_date}.csv`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
    
    setExportDialogOpen(false);
    swal("Success", "CSV report downloaded successfully!", "success");
  };

  // Handle export
  const handleExport = () => {
    if (exportFormat === "pdf") {
      generatePDFReport();
    } else if (exportFormat === "csv") {
      exportCSV();
    }
  };

  return (
    <Box sx={{ flexGrow: 1, minHeight: '100vh', backgroundColor: 'background.default' }}>
      {/* Header */}
      <AppBar position="static" elevation={2} sx={{ backgroundColor: PRIMARY_COLOR }}>
        <Toolbar>
          <TrendingUpIcon sx={{ mr: 2 }} />
          <Typography variant="h4" component="h1" sx={{ flexGrow: 1, fontWeight: 'bold' }}>
            Production Reports
          </Typography>
          <Button 
            variant="outlined" 
            startIcon={<DownloadIcon />}
            onClick={() => setExportDialogOpen(true)}
            sx={{ 
              borderRadius: 2, 
              color: 'white', 
              borderColor: 'white',
              '&:hover': {
                backgroundColor: 'rgba(255,255,255,0.1)',
                borderColor: 'white'
              }
            }}
          >
            Export Report
          </Button>
        </Toolbar>
      </AppBar>

      {/* Main Content */}
      <Box sx={{ p: 3 }}>
        <Paper sx={{ borderRadius: 2, border: 2, borderColor: PRIMARY_LIGHT, overflow: 'hidden' }}>
          {/* Report Controls */}
          <Box sx={{ p: 3, borderBottom: 1, borderColor: 'divider', backgroundColor: 'background.paper' }}>
            <Grid container spacing={3} alignItems="center">
              <Grid item xs={12} md={6}>
                <Typography variant="h6" gutterBottom>
                  Report Period
                </Typography>
                <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                  {reportPeriods.map((period) => (
                    <Button
                      key={period.value}
                      variant={reportPeriod === period.value ? "contained" : "outlined"}
                      onClick={() => handlePeriodChange(period.value)}
                      size="small"
                      sx={{ 
                        borderRadius: 2,
                        backgroundColor: reportPeriod === period.value ? PRIMARY_COLOR : 'transparent',
                        color: reportPeriod === period.value ? 'white' : PRIMARY_COLOR,
                        borderColor: PRIMARY_COLOR,
                        '&:hover': {
                          backgroundColor: reportPeriod === period.value ? PRIMARY_DARK : 'rgba(2, 74, 89, 0.04)',
                          borderColor: PRIMARY_DARK,
                        }
                      }}
                    >
                      {period.label}
                    </Button>
                  ))}
                </Box>
                
                {reportPeriod === "custom" && (
                  <Box sx={{ mt: 2, display: 'flex', gap: 2, alignItems: 'center', flexWrap: 'wrap' }}>
                    <TextField
                      label="Start Date"
                      type="date"
                      value={filters.start_date}
                      onChange={(e) => handleFilterChange('start_date', e.target.value)}
                      InputLabelProps={{ shrink: true }}
                      size="small"
                    />
                    <TextField
                      label="End Date"
                      type="date"
                      value={filters.end_date}
                      onChange={(e) => handleFilterChange('end_date', e.target.value)}
                      InputLabelProps={{ shrink: true }}
                      size="small"
                    />
                    <Button 
                      variant="contained" 
                      onClick={applyCustomDateRange}
                      size="small"
                      sx={{
                        backgroundColor: PRIMARY_COLOR,
                        '&:hover': {
                          backgroundColor: PRIMARY_DARK
                        }
                      }}
                    >
                      Apply
                    </Button>
                  </Box>
                )}
              </Grid>

              <Grid item xs={12} md={6}>
                <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end', flexWrap: 'wrap' }}>
                  <Button
                    variant="outlined"
                    onClick={fetchComparisonData}
                    disabled={!reportData}
                    startIcon={<BarChartIcon />}
                    sx={{
                      color: PRIMARY_COLOR,
                      borderColor: PRIMARY_COLOR,
                      '&:hover': {
                        borderColor: PRIMARY_DARK,
                        backgroundColor: 'rgba(2, 74, 89, 0.04)',
                      }
                    }}
                  >
                    Compare with Previous
                  </Button>
                  <Button
                    variant="contained"
                    onClick={() => fetchReportData()}
                    startIcon={<CalendarIcon />}
                    sx={{
                      backgroundColor: SECONDARY_COLOR,
                      '&:hover': {
                        backgroundColor: '#e59400'
                      }
                    }}
                  >
                    Refresh Data
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </Box>

          {/* Report Content */}
          <Box sx={{ p: 3 }}>
            {loading ? (
              <Box sx={{ display: 'flex', justifyContent: 'center', p: 6 }}>
                <CircularProgress sx={{ color: PRIMARY_COLOR }} size={60} />
              </Box>
            ) : reportData ? (
              <Grid container spacing={4}>
                {/* Summary Stats */}
                <Grid item xs={12}>
                  <Typography variant="h5" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 3, color: PRIMARY_COLOR }}>
                    <MilkIcon /> Production Summary
                  </Typography>
                  <Grid container spacing={3}>
                    <Grid item xs={12} sm={6} md={3}>
                      <Card sx={{ textAlign: 'center', p: 3, backgroundColor: PRIMARY_COLOR, color: 'white', height: '100%' }}>
                        <Typography variant="h4" sx={{ fontWeight: 'bold', mb: 1 }}>
                          {formatNumber(reportData.total_milk_produced)}
                        </Typography>
                        <Typography variant="body1">Total Milk (L)</Typography>
                        {comparisonData && (
                          <Chip 
                            label={`${calculateChange(reportData.total_milk_produced, comparisonData.total_milk_produced)?.toFixed(1) || '0'}%`}
                            color={getChangeProps(calculateChange(reportData.total_milk_produced, comparisonData.total_milk_produced)).color}
                            size="small"
                            sx={{ mt: 1, color: 'white' }}
                          />
                        )}
                      </Card>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                      <Card sx={{ textAlign: 'center', p: 3, backgroundColor: SECONDARY_COLOR, color: 'white', height: '100%' }}>
                        <Typography variant="h4" sx={{ fontWeight: 'bold', mb: 1 }}>
                          {reportData.total_sessions || 0}
                        </Typography>
                        <Typography variant="body1">Total Sessions</Typography>
                        {comparisonData && (
                          <Chip 
                            label={`${calculateChange(reportData.total_sessions, comparisonData.total_sessions)?.toFixed(1) || '0'}%`}
                            color={getChangeProps(calculateChange(reportData.total_sessions, comparisonData.total_sessions)).color}
                            size="small"
                            sx={{ mt: 1, color: 'white' }}
                          />
                        )}
                      </Card>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                      <Card sx={{ textAlign: 'center', p: 3, backgroundColor: PRIMARY_LIGHT, color: 'white', height: '100%' }}>
                        <Typography variant="h4" sx={{ fontWeight: 'bold', mb: 1 }}>
                          {formatNumber(reportData.average_yield_per_session)}
                        </Typography>
                        <Typography variant="body1">Avg Yield/Session (L)</Typography>
                        {comparisonData && (
                          <Chip 
                            label={`${calculateChange(reportData.average_yield_per_session, comparisonData.average_yield_per_session)?.toFixed(1) || '0'}%`}
                            color={getChangeProps(calculateChange(reportData.average_yield_per_session, comparisonData.average_yield_per_session)).color}
                            size="small"
                            sx={{ mt: 1, color: 'white' }}
                          />
                        )}
                      </Card>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                      <Card sx={{ textAlign: 'center', p: 3, backgroundColor: '#4caf50', color: 'white', height: '100%' }}>
                        <Typography variant="h4" sx={{ fontWeight: 'bold', mb: 1 }}>
                          {reportData.unique_cows_milked || 0}
                        </Typography>
                        <Typography variant="body1">Cows Milked</Typography>
                        {comparisonData && (
                          <Chip 
                            label={`${calculateChange(reportData.unique_cows_milked, comparisonData.unique_cows_milked)?.toFixed(1) || '0'}%`}
                            color={getChangeProps(calculateChange(reportData.unique_cows_milked, comparisonData.unique_cows_milked)).color}
                            size="small"
                            sx={{ mt: 1, color: 'white' }}
                          />
                        )}
                      </Card>
                    </Grid>
                  </Grid>
                </Grid>

                {/* Top Producing Cows */}
                {reportData.top_producing_cows && reportData.top_producing_cows.length > 0 && (
                  <Grid item xs={12} md={6}>
                    <Card sx={{ p: 3, height: '100%' }}>
                      <Typography variant="h6" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1, color: PRIMARY_COLOR }}>
                        <EmojiEventsIcon /> Top Producing Cows
                      </Typography>
                      <TableContainer>
                        <Table size="small">
                          <TableHead>
                            <TableRow>
                              <TableCell>Rank</TableCell>
                              <TableCell>Cow</TableCell>
                              <TableCell align="right">Yield (L)</TableCell>
                              <TableCell align="right">Sessions</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {reportData.top_producing_cows.map((cow, index) => (
                              <TableRow key={cow.animal?.id || index} hover>
                                <TableCell>
                                  <Chip 
                                    label={`#${index + 1}`} 
                                    size="small" 
                                    sx={{
                                      backgroundColor: index === 0 ? SECONDARY_COLOR : 'default',
                                      color: index === 0 ? 'white' : 'inherit'
                                    }}
                                  />
                                </TableCell>
                                <TableCell>
                                  <Box>
                                    <Typography variant="body2" fontWeight="bold">
                                      {cow.animal?.tag_number || 'Unknown'}
                                    </Typography>
                                    <Typography variant="body2" color="textSecondary">
                                      {cow.animal?.name || 'Unnamed'}
                                    </Typography>
                                  </Box>
                                </TableCell>
                                <TableCell align="right">
                                  <Typography variant="body2" fontWeight="bold" sx={{ color: PRIMARY_COLOR }}>
                                    {formatNumber(cow.total_yield)}
                                  </Typography>
                                </TableCell>
                                <TableCell align="right">
                                  <Typography variant="body2">
                                    {cow.session_count}
                                  </Typography>
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Card>
                  </Grid>
                )}

                {/* Top Operators */}
                {reportData.top_operators && reportData.top_operators.length > 0 && (
                  <Grid item xs={12} md={6}>
                    <Card sx={{ p: 3, height: '100%' }}>
                      <Typography variant="h6" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1, color: PRIMARY_COLOR }}>
                        <PeopleIcon /> Top Operators
                      </Typography>
                      <TableContainer>
                        <Table size="small">
                          <TableHead>
                            <TableRow>
                              <TableCell>Rank</TableCell>
                              <TableCell>Operator</TableCell>
                              <TableCell align="right">Yield (L)</TableCell>
                              <TableCell align="right">Sessions</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {reportData.top_operators.map((operator, index) => (
                              <TableRow key={operator.operator?.id || index} hover>
                                <TableCell>
                                  <Chip 
                                    label={`#${index + 1}`} 
                                    size="small" 
                                    sx={{
                                      backgroundColor: index === 0 ? SECONDARY_COLOR : 'default',
                                      color: index === 0 ? 'white' : 'inherit'
                                    }}
                                  />
                                </TableCell>
                                <TableCell>
                                  <Box>
                                    <Typography variant="body2" fontWeight="bold">
                                      {operator.operator ? 
                                        `${operator.operator.first_name} ${operator.operator.last_name}` : 
                                        `Operator ${operator.operator_id || 'Unknown'}`
                                      }
                                    </Typography>
                                    {operator.operator?.email && (
                                      <Typography variant="body2" color="textSecondary">
                                        {operator.operator.email}
                                      </Typography>
                                    )}
                                  </Box>
                                </TableCell>
                                <TableCell align="right">
                                  <Typography variant="body2" fontWeight="bold" sx={{ color: PRIMARY_COLOR }}>
                                    {formatNumber(operator.total_yield)}
                                  </Typography>
                                </TableCell>
                                <TableCell align="right">
                                  <Typography variant="body2">
                                    {operator.session_count}
                                  </Typography>
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Card>
                  </Grid>
                )}

                {/* Comparison Data */}
                {comparisonData && (
                  <Grid item xs={12}>
                    <Card sx={{ p: 3 }}>
                      <Typography variant="h6" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1, color: PRIMARY_COLOR }}>
                        <BarChartIcon /> Performance Comparison
                      </Typography>
                      <TableContainer>
                        <Table>
                          <TableHead>
                            <TableRow>
                              <TableCell>Metric</TableCell>
                              <TableCell align="right">Current Period</TableCell>
                              <TableCell align="right">Previous Period</TableCell>
                              <TableCell align="right">Change</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            <TableRow hover>
                              <TableCell>
                                <Typography variant="body2" fontWeight="bold">
                                  Total Milk Production
                                </Typography>
                              </TableCell>
                              <TableCell align="right">
                                <Typography variant="body2">
                                  {formatNumber(reportData.total_milk_produced)} L
                                </Typography>
                              </TableCell>
                              <TableCell align="right">
                                <Typography variant="body2">
                                  {formatNumber(comparisonData.total_milk_produced)} L
                                </Typography>
                              </TableCell>
                              <TableCell align="right">
                                <Chip 
                                  label={`${calculateChange(reportData.total_milk_produced, comparisonData.total_milk_produced)?.toFixed(1) || '0'}%`}
                                  color={getChangeProps(calculateChange(reportData.total_milk_produced, comparisonData.total_milk_produced)).color}
                                  size="small"
                                />
                              </TableCell>
                            </TableRow>
                            <TableRow hover>
                              <TableCell>
                                <Typography variant="body2" fontWeight="bold">
                                  Average Yield/Session
                                </Typography>
                              </TableCell>
                              <TableCell align="right">
                                <Typography variant="body2">
                                  {formatNumber(reportData.average_yield_per_session)} L
                                </Typography>
                              </TableCell>
                              <TableCell align="right">
                                <Typography variant="body2">
                                  {formatNumber(comparisonData.average_yield_per_session)} L
                                </Typography>
                              </TableCell>
                              <TableCell align="right">
                                <Chip 
                                  label={`${calculateChange(reportData.average_yield_per_session, comparisonData.average_yield_per_session)?.toFixed(1) || '0'}%`}
                                  color={getChangeProps(calculateChange(reportData.average_yield_per_session, comparisonData.average_yield_per_session)).color}
                                  size="small"
                                />
                              </TableCell>
                            </TableRow>
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Card>
                  </Grid>
                )}
              </Grid>
            ) : (
              <Card sx={{ textAlign: 'center', p: 6 }}>
                <CardContent>
                  <TrendingUpIcon sx={{ fontSize: 64, color: PRIMARY_COLOR, mb: 2 }} />
                  <Typography variant="h5" sx={{ color: PRIMARY_COLOR }} gutterBottom>
                    No Report Data Available
                  </Typography>
                  <Typography variant="body2" color="textSecondary" sx={{ mb: 3 }}>
                    Select a period to generate milk production reports and analytics
                  </Typography>
                  <Button 
                    variant="contained" 
                    onClick={() => fetchReportData()}
                    size="large"
                    startIcon={<BarChartIcon />}
                    sx={{
                      backgroundColor: SECONDARY_COLOR,
                      '&:hover': {
                        backgroundColor: '#e59400'
                      }
                    }}
                  >
                    Generate Report
                  </Button>
                </CardContent>
              </Card>
            )}
          </Box>
        </Paper>
      </Box>

      {/* Export Dialog */}
      <Dialog 
        open={exportDialogOpen} 
        onClose={() => setExportDialogOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Typography variant="h6">Export Report</Typography>
            <IconButton onClick={() => setExportDialogOpen(false)}>
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent>
          <FormControl fullWidth sx={{ mt: 2 }}>
            <InputLabel>Export Format</InputLabel>
            <Select
              value={exportFormat}
              onChange={(e) => setExportFormat(e.target.value)}
              label="Export Format"
            >
              <MenuItem value="pdf">PDF Document</MenuItem>
              <MenuItem value="csv">CSV Spreadsheet</MenuItem>
            </Select>
          </FormControl>
          <Alert severity="info" sx={{ mt: 2 }}>
            {exportFormat === 'pdf' 
              ? 'Export as printable PDF document with charts and summary tables.'
              : 'Export as CSV spreadsheet for data analysis in Excel or other applications.'
            }
          </Alert>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setExportDialogOpen(false)}>Cancel</Button>
          <Button 
            onClick={handleExport} 
            variant="contained" 
            disabled={generating}
            startIcon={generating ? <CircularProgress size={20} /> : <DownloadIcon />}
            sx={{
              backgroundColor: SECONDARY_COLOR,
              '&:hover': {
                backgroundColor: '#e59400'
              }
            }}
          >
            {generating ? 'Generating...' : 'Export Report'}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default ProductionReportPage;